import { WpEtEnrollment } from './wp-et-enrollment.model';

export class WpFamilyAssessment {
  constructor(
          public id?: number,
          public assessmentDt?: any,
          public famAssessentType?: string,
          public permPlaceSw?: string,
          public permPlaceDesc?: string,
          public ownsHomeSw?: string,
          public mortgageAmt?: number,
          public rentHomeSw?: string,
          public rentAmt?: number,
          public shareHomeSw?: string,
          public sharePersonName?: string,
          public limitedEmpSw?: string,
          public limitedEmpDesc?: string,
          public receivingServicesCd?: string,
          public barriersSw?: string,
          public familyBarriersCd?: any,
          public familyBarriersOthers?: any,
          public transportBarriersCd?: any,
          public transportBarriersOthers?: any,
          public personalBarriersCd?: any,
          public personBarriersOthers?: any,
          public drugAlcoholHistorySw?: string,
          public drugTestSw?: string,
          public passTestSw?: string,
          public alcoholSupportSw?: string,
          public voluntarySw?: string,
          public lostJobSw?: string,
          public lawTroubleSw?: string,
          public memoryLossSw?: string,
          public familyToldSw?: string,
          public fightArgueSw?: string,
          public spouseAlcoholSw?: string,
          public overcomeAlcoholSw?: string,
          public lastUpdatedDt?: any,
          public hospitalizedSw?: string,
          public statusCd?: string,
          public wpEtEnrollment?: WpEtEnrollment,
      ) {
      }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-family-assessment.model.ts